import { Injectable } from '@angular/core';
import { AccessManagerService } from '../accessManager/accessManager.service';
import { FeaturePermissionsCfgService } from './featurePermissionsCfg.service';
import { AccessManagerResourceActionType } from '../accessManager/accessManager.models';

@Injectable({
    providedIn: 'root'
})
export class FeaturePermissionsService {
    constructor(private cfg: FeaturePermissionsCfgService, private accessManagerService: AccessManagerService) {
    }

    public async professionalsEnabled(): Promise<boolean> {
        let permission = await this.accessManagerService.getResourcePermissions(this.cfg.getCfg().professionalsResourceId);
        return permission.getResourceAction(AccessManagerResourceActionType.ApplicationAccess);
    }
}
